// Meta (Facebook) Pixel + Conversions API helpers.
import { useEffect } from "react";
import { API } from "@/lib/api";

export const PIXEL_ID = "1390161859661510";

function readCookie(name) {
  const m = typeof document !== "undefined" && document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : undefined;
}

export function getFbCookies() {
  return { fbp: readCookie("_fbp"), fbc: readCookie("_fbc") };
}

// Browser Pixel track. Pass eventID to enable CAPI de-duplication.
export function fbTrack(event, data = {}, eventID) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event, data, eventID ? { eventID } : undefined);
  }
}

// Re-init the pixel with raw PII for Advanced Matching (Meta hashes client-side).
export function fbAdvancedMatch({ email, phone, firstName, lastName, city } = {}) {
  if (typeof window === "undefined" || !window.fbq) return;
  const am = {};
  if (email) am.em = String(email).trim().toLowerCase();
  if (phone) am.ph = String(phone).replace(/\D/g, "");
  if (firstName) am.fn = String(firstName).trim().toLowerCase();
  if (lastName) am.ln = String(lastName).trim().toLowerCase();
  if (city) am.ct = String(city).trim().toLowerCase();
  am.country = "in";
  window.fbq("init", PIXEL_ID, am);
}

// Fire-and-forget server-side Conversions API event (deduped by event_id).
export function sendCapi({ event_name, event_id, user_data = {}, custom_data = {} }) {
  try {
    const { fbp, fbc } = getFbCookies();
    const body = {
      event_name,
      event_id,
      event_source_url: typeof window !== "undefined" ? window.location.href : undefined,
      fbp,
      fbc,
      user_data,
      custom_data,
    };
    fetch(`${API}/meta/capi`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
}

// Hook: fire ViewContent once when an info page mounts.
export function useViewContent(contentName) {
  useEffect(() => {
    fbTrack("ViewContent", { content_name: contentName });
  }, [contentName]);
}

export const LEAD_CONTENT = {
  sponsor: "Sponsor Enquiry",
  exhibit: "Exhibit Enquiry",
  contact: "Brochure / Contact",
  brochure: "Brochure / Contact",
  prospectus: "Brochure / Contact",
  market_report: "Brochure / Contact",
  calculator_report: "Calculator Report",
  speaker: "Speaker Enquiry",
  nomination: "Award Nomination",
};

// Fire Lead (browser Pixel + CAPI, deduped by event_id). Skips low-intent newsletter.
export function trackLead(formType, submissionId, userData = {}) {
  if (!submissionId || formType === "newsletter") return;
  const content_name = LEAD_CONTENT[formType] || "Enquiry";
  const event_id = `lead_${submissionId}`;
  fbTrack("Lead", { content_name }, event_id);
  sendCapi({ event_name: "Lead", event_id, user_data: userData, custom_data: { content_name } });
}

